export const RETAIL_PRICE_LABEL = "Retail Price";

// Returns "$x.xx", or null when no usable retail price exists so callers can hide the row.
export const formatRetailPrice = (value) => {
  if (value === null || value === undefined || value === "") return null;
  const num = Number(value);
  if (!Number.isFinite(num) || num <= 0) return null;
  return `$${num.toFixed(2)}`;
};
